import { render } from "./Editor.vue?vue&type=template&id=64f1c312&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=64f1c312&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f1c312"]])

export default __exports__